import { c as _c } from "react/compiler-runtime";
import type { PaginationConfig, TablePaginationConfig } from '@netpurpose/types';
import { useCallback, useMemo, useState } from 'react';
import { apiConfig } from '../config';
export const usePagination = t0 => {
  const $ = _c(17);
  const {
    perPage: t1,
    withTotalRow: t2
  } = t0;
  const perPage = t1 === undefined ? apiConfig.defaultFetchSize : t1;
  const withTotalRow = t2 === undefined ? false : t2;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(undefined);
  const [pageSize, setPageSize] = useState(perPage);
  let t3;
  if ($[0] !== pageSize || $[1] !== withTotalRow) {
    t3 = currentPageNum => withTotalRow && currentPageNum === 1 ? pageSize + 1 : pageSize;
    $[0] = pageSize;
    $[1] = withTotalRow;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getTablePageSize = t3;
  const t4 = getTablePageSize(currentPage);
  let t5;
  if ($[3] !== totalCount) {
    t5 = typeof totalCount === "number" ? {
      total: totalCount
    } : {};
    $[3] = totalCount;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== currentPage || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      ...apiConfig.defaultTablePagination,
      pageSize: t4,
      current: currentPage,
      ...t5
    };
    $[5] = currentPage;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const tablePaginationConfig = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = pagination => {
      if (pagination.current) {
        setCurrentPage(pagination.current);
      }
      if (pagination.pageSize) {
        setPageSize(pagination.pageSize);
      }
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleTableChange = t7;
  let t8;
  if ($[10] !== totalCount) {
    t8 = typeof totalCount === "number" ? {
      totalCount
    } : {};
    $[10] = totalCount;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== currentPage || $[13] !== pageSize || $[14] !== t8 || $[15] !== tablePaginationConfig) {
    t9 = {
      currentPage,
      ...t8,
      pageSize,
      setCurrentPage,
      setTotalCount,
      setPageSize,
      handleTableChange,
      tablePaginationConfig
    };
    $[12] = currentPage;
    $[13] = pageSize;
    $[14] = t8;
    $[15] = tablePaginationConfig;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};